import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddUnderCarriageModal from "./components/AddUnderCarriageModal";
import UnderCarriageTable from "./components/UnderCarriageTable";
import {
  selectUnderCarriageList,
  selectUnderCarriageLoading,
  selectUnderCarriageMeta,
} from "./redux/selector";
import underCarriageSaga from "./redux/saga";
import { underCarriageActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const UnderCarriage = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: underCarriageSaga,
  });

  const rows = useSelector(selectUnderCarriageList);
  const loading = useSelector(selectUnderCarriageLoading);
  const meta = useSelector(selectUnderCarriageMeta);

  useEffect(() => {
    dispatch(underCarriageActions.getUnderCarriageList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(underCarriageActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("SIDEBAR.SUB_CHASSIS_TYPE")}
            iconPosition="end"
          />
          <Box dir="ltr">
            <AddButton
              label={t("UNDER_CARRIAGE.ACTIONS.ADD")}
              onClick={() => dispatch(underCarriageActions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <UnderCarriageTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddUnderCarriageModal />
    </Box>
  );
};

export default UnderCarriage;
